import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_194: DocMigration = {
  maxSchemaVersion: "0.0.194",
  description: "Add default values for updated window alignment",
  apply(json: any) {
    for (const openingId in json.openings) {
      const opening = json.openings[openingId];

      if (opening.type !== "WINDOW") {
        continue;
      }

      opening.verticalAlignment = "BO_WINDOW_HEADER";
      opening.horizontalDatum = "WINDOW_HEAD_HEIGHT";
    }

    return json;
  },
};

export default migration_0_0_194;
